import { client } from "@/api/client";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetDistributorCodeRules {
  constructor(
      private readonly q_dispatcher: QueryDispatcher,
      private readonly frontend
    ) {}
  
    async run() {
      let args = {}
  
      try {
        let data = await this.q_dispatcher.dispatch('get.distributor.code.rules', args)
        this.frontend.signupRules = data
      } catch (error) {
        console.error("Error fetching distributor code rules:", error);
      }
    }
}